export interface IBehavioralHealthResource {
    appointmentId: number;
    behavioralHealthId?: number;
    jsonString: string;
    }